<template>
  <div class="category-container">
    <PlayTabs class="category-tabs" v-model="category" :tabs="tabs" @tab-click="handleTabClick"></PlayTabs>
  </div>
</template>

<script>
import PlayTabs from "../tabs";

export default {
  components: { PlayTabs },
  props: {
    tabs: Array,
    categoryValue: String
  },
  data() {
    return {
      category: this.categoryValue
    }
  },
  mounted() { },
  watch: {
    categoryValue: {
      handler(newValue) {
        this.category = newValue;
      }
    }
  },
  methods: {
    handleTabClick(tab) {
      this.$emit("category-change", tab.value);
    }
  }
}
</script>

<style lang="scss" scoped>
@import "./index.scss";
</style>